import { useQuery } from "@tanstack/react-query"
import { api } from "@/services/api"

export default function useGetCalendarRangesInfo() {
  const query = useQuery({
    queryKey: ["get-user-course-dates"],
    queryFn: api.cronos.courses.getUserDates,
    refetchOnWindowFocus: false,
  })

  return query
}
